
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import {
  getExpandPropertyList,
  addBatchImportDevice,
  importDevice
  // downTemplate
} from "@/api/api-basic";
import divScroll from "@/components/div-scroll/div-scroll.vue";
import uploadImage from "@/components/upload-image/upload-image.vue";
import piExport from "@/components/pi-export/pi-export.vue";
import { getOptionList } from "@/api/api-dict";
import { getProtocolList } from "@/api/api-interconnection";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-div-scroll": divScroll,
    "pi-upload-image": uploadImage,
    "pi-export": piExport
  }
})
export default class PiModelAdd extends Vue {
  @Prop({
    default: () => {
      return [];
    },
    type: Array
  })
  private devTypeList!: object[];
  private modalTitle = i18n.t("equipmentList.export");
  private modalShow = false;
  private loading = false;
  private exportLoading = false;
  private protocolShow = false;

  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: i18n.t("equipmentList.serialNumber"),
      key: "sn",
      minWidth: 130
    },
    {
      title: i18n.t("equipmentModel.deviceType"),
      key: "deviceTypeName",
      minWidth: 130
    },
    {
      title: i18n.t("equipmentModel.deviceModelName"),
      key: "deviceModelType",
      minWidth: 130
    },
    {
      title: i18n.t("remark"),
      key: "remark",
      minWidth: 130
    }
  ];
  private total = 0;
  private dcNum = 0;
  private acNum = 0;
  private FormData: objAny = {};
  private formItem: objAny = {
    protocolPkId: ""
  };
  private ruleInline: objAny = {
    protocolPkId: [
      {
        required: true,
        message: i18n.t("equipmentList.protocolPkIdPl"),
        trigger: "change"
      }
    ]
  };
  private protocolList: object[] = [];
  private extParamList: object[] = [];

  public open(): void {
    this.modalShow = true;
    if (!this.FormData.$el) {
      this.$nextTick((): void => {
        this.FormData = this.$refs["formItem"];
      });
    } else {
      this.handleReset();
    }
    this.tableList = []; //[];
    this.total = 0;
    this.dcNum = 0;
    this.acNum = 0;
    this.getProtocolList();
  }
  public handleReset() {
    this.FormData.resetFields();
  }

  async uploadFile(file: File): Promise<void> {
    const ret = await importDevice({ file: file });
    if (ret.status === this.$config.apiStatus) {
      this.tableList = ret.data;
      this.total = ret.data.length;
      let dcNum = 0;
      let acNum = 0;
      ret.data.map((item: objAny) => {
        // 2: 交流桩 3:直流充电机
        if (item.deviceType == 2) {
          acNum++;
        } else if (item.deviceType == 3) {
          dcNum++;
        }
      });
      this.dcNum = dcNum;
      this.acNum = acNum;
    }
    const uploadImage: objAny = this.$refs.uploadImage;
    uploadImage.resetFile();
  }
  public protocolChange(val: string) {
    this.getExpandPropertyList(val);
    this.protocolShow = true;
  }
  async getProtocolList(): Promise<void> {
    const ret = await getProtocolList({
      protocolType: 0
    });
    if (ret.status === this.$config.apiStatus) {
      this.protocolList = ret.data;
    }
  }
  async getExpandPropertyList(protocolPkId: string) {
    const ret = await getExpandPropertyList({
      protocolPkId: protocolPkId
    });
    if (ret.status === this.$config.apiStatus) {
      const data: object[] = ret.data || [];

      if (data.length > 0) {
        const extParamList: object[] = [];
        const propertyDictPkIdList: string[] = [];
        data.map((item: objAny) => {
          propertyDictPkIdList.push(item.propertyDictPkId);
          const json: objAny = {
            propertyPkId: item.propertyPkId,
            propertyDictPkId: item.propertyDictPkId,
            propertyName: item.propertyName,
            propertyValue: ""
          };

          extParamList.push(json);
        });

        getOptionList(propertyDictPkIdList).then(dataObj => {
          for (const i in dataObj) {
            extParamList.map((item: objAny) => {
              if (item.propertyDictPkId == i) {
                item.optionList = dataObj[i];
                if (dataObj[i][0] && item.propertyValue == "") {
                  item.propertyValue = dataObj[i][0].itemKey;
                }
              }
            });
          }
          this.extParamList = extParamList;
        });
      } else {
        this.protocolShow = false;
        this.extParamList = [];
      }
    }
  }
  public handleSubmit(): void {
    this.FormData.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      }
    });
  }
  async submitData(): Promise<void> {
    const extParamList: object[] = [];
    if (this.extParamList.length > 0) {
      this.extParamList.map((item: objAny) => {
        extParamList.push({
          propertyPkId: item.propertyPkId,
          propertyValue: item.propertyValue
        });
      });
    }
    const deviceParams: objAny[] = [];
    this.tableList.map((item: objAny) => {
      deviceParams.push({
        deviceModelPkId: item.deviceModelPkId,
        deviceType: item.deviceType,
        sn: item.sn,
        protocolPkId: this.formItem.protocolPkId,
        extParamList: extParamList
      });
    });
    this.loading = true;
    const ret = await addBatchImportDevice({
      deviceParams: deviceParams
    });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("addSuccess"));
      this.$emit("success");
      this.modalShow = false;
    }
    this.loading = false;
  }

  // mounted() {}
}
